import React, { useState } from 'react';
// import { MOBILE_MONEY_NETWORKS, PAYMENT_OPTIONS } from "../../../../resources/enums";
import { Formik } from 'formik';
import * as Yup from 'yup';

import { Policy } from '../../../models/policy/Policy';
import {
  getFormattedPhoneNumber,
  getListFromEnum,
  getPhoneNumberFromShortCodeFormat
} from '../../../utils/miscFunctions';
import useUserAccount from '../../../hooks/userAccountHook';
import Button from '../../../components/form-control/Button';
import SelectMenu, { ISelectMenuItemValue } from '../../../components/form-control/SelectMenu';
import Input from '../../../components/form-control/Input';
import { MOBILE_MONEY_NETWORKS } from '../../../resources/enums';
import { HomePolicy } from '../../../models/homePolicy/HomePolicy';

interface IProvideHubtelMomoDetailsProps {
  onProceed: (data: {
    phone: string;
    network?: MOBILE_MONEY_NETWORKS;
    policyNumber: string;
  }) => void;
  policy: Policy | HomePolicy | undefined;
  onClose?: () => void;
}

const NETWORKS = getListFromEnum(MOBILE_MONEY_NETWORKS);

const ProvideItConsortiumMomoDetails = (props: IProvideHubtelMomoDetailsProps): JSX.Element => {
  const { getProfile } = useUserAccount();

  return (
    <>
      
      <div className="">
        <div>
          <Formik
            initialValues={{
              phone: getPhoneNumberFromShortCodeFormat(
                props.policy?.applicant?.phoneNumber ?? getProfile().phone ?? ''
              ),
              policyNumber: props.policy?.ref ?? ''
              //   network: ''
            }}
            validateOnBlur
            validationSchema={Yup.object().shape({
              phone: Yup.string().trim().required('Mobile money wallet number is required.')
              //   network: Yup.string().required('Mobile money network is required.')
            })}
            onSubmit={(values) => {
          

              props.onProceed({
                phone: getFormattedPhoneNumber(values.phone),
                policyNumber: props.policy?.ref ?? ''
                // network: _network
              });
            }}>
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleSubmit,
              handleChange,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="mt-5 flex flex-col space-y-4">
                  <Input
                    type="tel"
                    id="phone"
                    label="Your mobile money wallet number"
                    placeholder="Eg. 0245000000"
                    className="rounded-[0px] placeholder-[#848484] focus:ring-primary-border px-3"
                    value={values.phone ?? ''}
                    onChange={handleChange}
                    onBlur={handleChange}
                    error={touched?.phone ? errors.phone : undefined}
                    helperText={touched?.phone ? errors.phone : undefined}
                    // countryCode
                  />
                 
                </div>

                <div className="w-full flex gap-4 mt-6 !mb-4">
                  <Button
                    type="button"
                    label="Cancel"
                    onClick={props.onClose}
                    bgColor='secondary'
                  fullWidth
                    // loading={submitting}
                    // disabled={submitting}
                  />
                  <Button
                    type="submit"
                    label="Proceed"
                    bgColor='primary'
              fullWidth
                    loading={isSubmitting}
                    disabled={isSubmitting}
                  />
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default ProvideItConsortiumMomoDetails;
